<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Business Cards</h1>
      <div class="text-large">Look at that subtle colouring. The tasteful thickness. <br/>It even has a watermark!</div>
    </div>
  </div>
<Templates Category="business-cards" Workspace="extras" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Templates from "@/components/TemplateCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Templates
  }
};
</script>
